import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">平台优势</h2>
          <p className="text-sm text-foreground-500">为什么数百万用户选择吃瓜视频</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureItems.map((item) => (
            <div key={item.title} className="p-6 rounded-2xl bg-background-100 hover:bg-background-200 transition-colors group cursor-default">
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}